import React from 'react'
import { ModalBase, IModalBaseProps, MODAL_TYPES } from 'transfix-ui/components/Modals'
import { Typography } from 'transfix-ui/core'

interface IDeleteScheduleVinProps extends Omit<IModalBaseProps, 'modalType'> {
  onConfirm: () => void
  onCancel: () => void
}

export const DeleteScheduleVinModal = ({
  onCancel,
  onConfirm,
  open = false,
  ...props
}: IDeleteScheduleVinProps) => {
  const actions: IModalBaseProps['actions'] = [
    {
      label: 'Cancel',
      action: () => {
        onCancel()
      },
      type: 'dismiss',
      dataTest: 'cancel-button',
    },
    {
      label: 'Delete',
      action: () => {
        onConfirm()
      },
      type: 'confirm',
      dataTest: 'vin-confirm-button',
    },
  ]

  return (
    <ModalBase
      dataTest='delete-schedule-vin'
      modalType={MODAL_TYPES.confirmation}
      size={5}
      open={open}
      actions={actions}
      title='Delete Scheduled VINs'
      {...props}>
      <Typography variant='body2'>
        Are you sure that you want to delete this scheduled VIN?
      </Typography>
    </ModalBase>
  )
}
